export const loadExternalScript = function (location: string, callback: () => void) {
  var fileRef = document.createElement('script');
  fileRef.setAttribute('type', 'text/javascript');
  if (callback) {
    fileRef.onload = function () {
      callback();
    };
  }
  fileRef.setAttribute('src', location);
  document.head.appendChild(fileRef);
};
